'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Generate Search URL String -
 * Gets an object of searchData in this format:
 *
 * {
 *   searchValue: "keywords",
 *   selectedFilters: {
 *     sectors[53]: "53"
 *     sectors[57]: "57"
 *   },
 *   sort: "rel",
 * }
 *
 * And returns a string to append to a GET URL like this:
 * ?sort=rel&sectors[]=53&sectors[]=57&searchValue=keywords
 */

var formatFiltersList = function formatFiltersList(selectedFilters) {
  if (!selectedFilters) return false;

  // Convert the object into an array that we can loop through
  var selectedFiltersList = [];
  Object.keys(selectedFilters).forEach(function (key) {
    /*
     * Remove the number inside the square brackets in the field name - it's
     * needed for the React state object but Craft doesn't use it.
     */
    var fieldName = encodeURIComponent(key.replace(/\[.*\]/g, '[]'));
    var value = encodeURIComponent(selectedFilters[key]);
    var item = {};
    item[fieldName] = value;
    selectedFiltersList.push(item);
  });

  return selectedFiltersList;
};

// Returns true if object is not empty
var checkIfObjectKeysExist = function checkIfObjectKeysExist(obj) {
  return Object.keys(obj).length > 0;
};

var generateSearchUrlString = function generateSearchUrlString(searchData) {
  // Gather the search facets
  var sort = searchData && searchData.sort ? { sort: encodeURIComponent(searchData.sort) } : {};
  var selectedFiltersList = searchData && searchData.selectedFilters ? formatFiltersList(searchData.selectedFilters) : [];
  var keywords = searchData && searchData.searchValue ? { searchValue: encodeURIComponent(searchData.searchValue) } : {};

  // Combine all the aspects into a single object, and turn into a string
  var searchCriteria = [sort].concat(_toConsumableArray(selectedFiltersList), [keywords]);

  // Returns true if at least one object in searchCriteria is not empty
  var searchCriteriaGetBoolean = searchCriteria.some(checkIfObjectKeysExist);

  if (!searchCriteriaGetBoolean) return '';

  var searchQuery = '?' + searchCriteria.map(function (queryItem) {
    return Object.keys(queryItem).map(function (key) {
      return key + '=' + queryItem[key];
    });
  }).join('&');

  return searchQuery;
};

exports.default = generateSearchUrlString;